import { rememberMeCookieAsync, Event, SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { Account, Address } from 'shared/types/account';
import { ClaimInsuranceBody, WebAccountIdPayload } from 'shared/types/account/Account';
import { MakePaymentRequest } from 'shared/types/creditCard/CreditCard';
import { RecentlyViewedProducts } from 'shared/types/product/RecentlyViewedProducts';
import { SOACustomer, ValidateSOACustomerPayload } from 'shared/types/soa/customer/SoaCustomer';
import {
  HistoryOrders,
  OrderDetails,
  SOADashBoardOrders,
  SOAOrderDetailsPayload,
  SOAOrderHistoryPayload,
} from 'shared/types/soa/order/orders';
import {
  OrderDetailsResponse,
  OrderHistoryResponse,
  PreferencesResponse,
} from '@/components/customercenter-ui/components/customer-detail/types';
import { callActionMiddleware } from '@/helpers/utils/callActionHelper';
import { getSelectedDivision } from '@/helpers/utils/siteUtils';
import {
  AddAccountAddressAction,
  AddNewAddressAction,
  AddNoteAction,
  CatalogMailingHistoryAction,
  ChangeAccountPasswordAction,
  ConfirmAccountAction,
  CreditEnrollProtectionAction,
  GetAccountAction,
  GetAccountActionReturn,
  LoginAccountAction,
  LogoutAccountAction,
  MakePaymentAction,
  OrderByIdAction,
  OrderEventsAction,
  OrderNoteAction,
  OrderTrackLogAction,
  RefundCheckHistoryAction,
  RegisterAccountAction,
  RemoveAccountAddressAction,
  RequestAccountConfirmationEmailAction,
  RequestAccountPasswordResetAction,
  ResetAccountPasswordAction,
  SendCatalogAction,
  SendTracerAction,
  SetDefaultAccountBillingAddressAction,
  SetDefaultAccountShippingAddressAction,
  TokenizeCardAction,
  UpdateAccountAction,
  UpdateAccountAddressAction,
  UpdateCustomerAddressAction,
  UpdateCustomerDetailsAction,
  UpdateEmailAction,
  UpdatePhoneAction,
  AddDivisionAction,
  getCustomerNotesAction,
  getCustomerPreferenceAction,
  getOrderHistoryAction,
  updateCustomerPreferencesAction,
  CreateCustomerAction,
  updateRecentlyViewedProductsAction,
  CreditHistoryAction,
  CreditNotesAction,
  CustomerAddressAction,
  CustomerDetailsAction,
  ForgotPasswordAction,
  UpdateOrderAction,
  PhoneRecordingAction,
  ValidateAddressAction,
  HoldOrderAction,
  DecryptCreditCardAction,
  AddCreditCardAction,
  EditCreditCardAction,
  RemoveCreditCardAction,
  SetDefaultCreditCardAction,
  GetAccountDataAction,
  ReviewPaymentAction,
  GetSOACustomerAction,
  GetSOACustomerByCustomerIdAction,
  GetSOAOrderHistoryAction,
  GetSOAOrderHistoryForDashboardAction,
  GetSOAOrderDetailsAction,
  TokenizeAndUpdateOrderAction,
  CTAccountAction,
  SetSelectedSiteAction,
  FetchWebAccountIdAction,
  getOrderDetailsAction,
  GetIsRetiredBrand,
  SendClaimInsuranceEmailAction,
} from '../../types/actions/AccountActions';
import { ComposableCommerceEvents } from '../../types/events/ComposableCommerceEvents';
import {
  AddAccountAddressPayload,
  ChangeAccountPasswordPayload,
  ConfirmAccountPayload,
  LoginAccountPayload,
  RegisterAccountPayload,
  RemoveAccountAddressPayload,
  RequestAccountConfirmationEmailPayload,
  RequestAccountPasswordResetPayload,
  ResetAccountPasswordPayload,
  SetDefaultAccountBillingAddressPayload,
  SetDefaultAccountShippingAddressPayload,
  UpdateAccountAddressPayload,
  UpdateAccountPayload,
  CustomerNotesPayload,
  CustomerPreferencePayload,
  OrderHistoryPayload,
  AddressPayload,
  AddNotePayload,
  UpdateCustomerDetialsPayload,
  RefundHistoryPayload,
  CatalogMailingHistoryPayload,
  updateCustomerPreferencesPayload,
  SendCatalogPayload,
  UpdateEmailPayload,
  UpdatePhonePayload,
  OrderByIdPayload,
  TokenizeCardPayload,
  EnrollProtectionPayload,
  OrderTrackLogPayload,
  SendTracerPayload,
  AddDivisionPayload,
  CreateCustomerPayload,
  CreditHistory,
  CustomerAddressPayload,
  CustomerDetailsPayload,
  ForgotPassword,
  UpdateOrderPayload,
  PhoneRecordingPayload,
  ValidateAddress,
  HoldOrder,
  AddEditCreditCardPayload,
  RemoveCreditCardPayload,
  SetDefaultCreditCardPayload,
  SelectedSitePayload,
  OrderDetailsPayload,
} from '../../types/payloads/AccountPayloads';

export type AccountActions = {
  getAccount: GetAccountAction;
  login: LoginAccountAction;
  logout: LogoutAccountAction;
  register: RegisterAccountAction;
  confirm: ConfirmAccountAction;
  requestConfirmationEmail: RequestAccountConfirmationEmailAction;
  changePassword: ChangeAccountPasswordAction;
  requestResetPassword: RequestAccountPasswordResetAction;
  resetPassword: ResetAccountPasswordAction;
  updateAccount: UpdateAccountAction;
  getIsRetiredBrand: GetIsRetiredBrand;
  addAddress: AddAccountAddressAction;
  updateAddress: UpdateAccountAddressAction;
  removeAddress: RemoveAccountAddressAction;
  setDefaultBillingAddress: SetDefaultAccountBillingAddressAction;
  setDefaultShippingAddress: SetDefaultAccountShippingAddressAction;
  getCustomerNotes: getCustomerNotesAction;
  getCustomerPrefrence: getCustomerPreferenceAction;
  getOrderHistory: getOrderHistoryAction;
  getOrderDetails: getOrderDetailsAction;
  addNewAddress: AddNewAddressAction;
  updateCustomerAddress: UpdateCustomerAddressAction;
  addNote: AddNoteAction;
  updateCustomerDetails: UpdateCustomerDetailsAction;
  getCustomerRefundHistory: RefundCheckHistoryAction;
  getCustomerMailingHistory: CatalogMailingHistoryAction;
  makePayment: MakePaymentAction;
  updateCustomerPreferences: updateCustomerPreferencesAction;
  sendCatalog: SendCatalogAction;
  updateEmail: UpdateEmailAction;
  updatePhone: UpdatePhoneAction;
  addDivision: AddDivisionAction;
  getOrderById: OrderByIdAction;
  tokenizeCard: TokenizeCardAction;
  enrollCreditProtection: CreditEnrollProtectionAction;
  getOrderLogs: OrderTrackLogAction;
  addOrderNote: OrderNoteAction;
  sendTracer: SendTracerAction;
  getOrderEvents: OrderEventsAction;
  createCustomer: CreateCustomerAction;
  updateRecentlyViewedProducts: updateRecentlyViewedProductsAction;
  getCreditHistory: CreditHistoryAction;
  getCreditNotes: CreditNotesAction;
  getCustomerAddresses: CustomerAddressAction;
  getCustomerDetails: CustomerDetailsAction;
  forgotPassword: ForgotPasswordAction;
  sendClaimInsuranceEmail: SendClaimInsuranceEmailAction;
  updateOrder: UpdateOrderAction;
  startPhoneRecording: PhoneRecordingAction;
  stopPhoneRecording: PhoneRecordingAction;
  validateAddress: ValidateAddressAction;
  getHoldOrders: HoldOrderAction;
  decryptCreditCardData: DecryptCreditCardAction;
  addCreditCard: AddCreditCardAction;
  editCreditCard: EditCreditCardAction;
  removeCreditCard: RemoveCreditCardAction;
  setDefaultCreditCard: SetDefaultCreditCardAction;
  getAccountData: GetAccountDataAction;
  reviewPayment: ReviewPaymentAction;
  getSOACustomer: GetSOACustomerAction;
  getSOACustomerByCustomerId: GetSOACustomerByCustomerIdAction;
  getSOAOrderHistory: GetSOAOrderHistoryAction;
  getSOAOrderHistoryForDashboard: GetSOAOrderHistoryForDashboardAction;
  getSOAOrderDetails: GetSOAOrderDetailsAction;
  tokenizeAndUpdateOrder: TokenizeAndUpdateOrderAction;
  isCTAccount: CTAccountAction;
  selectedSiteInSession: SetSelectedSiteAction;
  fetchWebAccountId: FetchWebAccountIdAction;
};

const addressesAreEqual = function (firstAddress: Address, secondAddress: Address, compareIds: boolean) {
  return (
    !compareIds ||
    (compareIds &&
      firstAddress.addressId === secondAddress.addressId &&
      firstAddress.streetName === secondAddress.streetName &&
      firstAddress.streetNumber === secondAddress.streetNumber &&
      firstAddress.additionalStreetInfo === secondAddress.additionalStreetInfo &&
      firstAddress.additionalAddressInfo === secondAddress.additionalAddressInfo &&
      firstAddress.city === secondAddress.city &&
      firstAddress.state === secondAddress.state &&
      firstAddress.country === secondAddress.country &&
      firstAddress.postalCode === secondAddress.postalCode &&
      firstAddress.salutation === secondAddress.salutation &&
      firstAddress.firstName === secondAddress.firstName &&
      firstAddress.lastName === secondAddress.lastName &&
      firstAddress.isDefaultBillingAddress === secondAddress.isDefaultBillingAddress &&
      firstAddress.isDefaultShippingAddress === secondAddress.isDefaultShippingAddress &&
      firstAddress.phone === secondAddress.phone)
  );
};

export const getAccountActions = (sdk: SDK<ComposableCommerceEvents>): AccountActions => {
  return {
    reviewPayment: async (payload: MakePaymentRequest, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Response>({
        actionName: 'account/reviewPayment',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    fetchWebAccountId: async (payload: WebAccountIdPayload, options?: { serverOptions?: ServerOptions }) => {
      const response = await sdk.callAction<Response>({
        actionName: 'account/fetchWebAccountId',
        payload,
        serverOptions: options?.serverOptions,
      });
      return response;
    },
    getIsRetiredBrand: async (options?: { serverOptions?: ServerOptions }) => {
      const response = await sdk.callAction<Response>({
        actionName: 'account/isRetiredBrand',
        serverOptions: options?.serverOptions,
        query: { divisionCode: getSelectedDivision() ?? '' },
      });
      return response;
    },
    selectedSiteInSession: async (payload: SelectedSitePayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Response>({
        actionName: 'account/setSelectedSite',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },

    getAccount: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<GetAccountActionReturn>({
        actionName: 'account/getAccount',
        serverOptions: options.serverOptions,
      });

      if (response.isError === false && response.data.loggedIn && response.data.account) {
        sdk.trigger(
          new Event({
            eventName: 'accountFetched',
            data: {
              account: response.data.account,
            },
          }),
        );
      }
      return response;
    },
    getSOACustomer: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<SOACustomer>({
        actionName: 'account/getCustomerFromSOA',
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        // sdk.trigger(
        //   new Event({
        //     eventName: 'getSOACustomer',
        //     data: {
        //       soacustomer: response?.data,
        //     },
        //   }),
        // );
      }
      return response;
    },
    getSOACustomerByCustomerId: async (
      payload: ValidateSOACustomerPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<SOACustomer>({
        payload,
        actionName: 'account/getSOACustomerByCustomerId',
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        // sdk.trigger(
        //   new Event({
        //     eventName: 'getSOACustomer',
        //     data: {
        //       soacustomer: response?.data,
        //     },
        //   }),
        // );
      }
      return response;
    },
    getSOAOrderHistory: async (payload: SOAOrderHistoryPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<HistoryOrders>({
        actionName: 'account/getSOAOrderHistory',
        payload,
        serverOptions: options.serverOptions,
      });
      if (response.isError === false) {
        // sdk.trigger(
        //   new Event({
        //     eventName: 'getSOAOrderHistory',
        //     data: {
        //       soaOrders: response?.data,
        //     },
        //   }),
        // );
      }
      return response;
    },
    getSOAOrderDetails: async (payload: SOAOrderDetailsPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<OrderDetails>({
        actionName: 'account/getSOAOrderDetails',
        payload,
        serverOptions: options.serverOptions,
      });
      if (response.isError === false) {
        // sdk.trigger(
        //   new Event({
        //     eventName: 'getSOAOrderDetails',
        //     data: {
        //       orderDetails: response?.data,
        //     },
        //   }),
        // );
      }
      return response;
    },
    login: async (payload: LoginAccountPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const remember = payload.remember;
      payload.remember = undefined;

      const response = await callActionMiddleware<Account>({
        actionName: 'account/login',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        if (remember) {
          await rememberMeCookieAsync.set(true, options.serverOptions);
        }
        sdk.trigger(
          new Event({
            eventName: 'userLoggedIn',
            data: {
              account: response.data,
            },
          }),
        );
      }

      return response;
    },
    logout: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<void>({
        actionName: 'account/logout',
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        await rememberMeCookieAsync.remove(options.serverOptions);
        sdk.trigger(
          new Event({
            eventName: 'userLoggedOut',
            data: {},
          }),
        );
      }
      return response;
    },
    register: async (payload: RegisterAccountPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/register',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'userRegistered',
            data: {
              account: response.data,
            },
          }),
        );
      }
      return response;
    },
    confirm: async (payload: ConfirmAccountPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/confirm',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'accountConfirmed',
            data: {
              account: response.data,
            },
          }),
        );
      }
      return response;
    },
    requestConfirmationEmail: async (
      payload: RequestAccountConfirmationEmailPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<void>({
        actionName: 'account/requestConfirmationEmail',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'accountConfirmationEmailRequested',
            data: {
              email: payload.email,
            },
          }),
        );
      }
      return response;
    },
    changePassword: async (payload: ChangeAccountPasswordPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/password',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'passwordChanged',
            data: {},
          }),
        );
      }
      return response;
    },
    requestResetPassword: async (
      payload: RequestAccountPasswordResetPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<void>({
        actionName: 'account/requestReset',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'passwordResetRequested',
            data: {},
          }),
        );
      }
      return response;
    },
    resetPassword: async (payload: ResetAccountPasswordPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/reset',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'passwordReset',
            data: {},
          }),
        );
      }
      return response;
    },
    updateAccount: async (payload: UpdateAccountPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/update',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        sdk.trigger(
          new Event({
            eventName: 'accountUpdated',
            data: {
              account: response.data,
            },
          }),
        );
      }
      return response;
    },
    addAddress: async (payload: AddAccountAddressPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/addAddress',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        const newAddress = response.data.addresses?.find((address) => addressesAreEqual(address, payload, false));
        if (newAddress) {
          sdk.trigger(
            new Event({
              eventName: 'accountAddressAdded',
              data: {
                address: newAddress,
              },
            }),
          );
        }
      }
      return response;
    },
    updateAddress: async (payload: UpdateAccountAddressPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/updateAddress',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        const newAddress = response.data.addresses?.find((address) => addressesAreEqual(address, payload, true));
        if (newAddress) {
          sdk.trigger(
            new Event({
              eventName: 'accountAddressUpdated',
              data: {
                address: newAddress,
              },
            }),
          );
        }
      }
      return response;
    },
    removeAddress: async (payload: RemoveAccountAddressPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/removeAddress',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        if (!response.data.addresses?.find((address) => address.addressId === payload.addressId)) {
          sdk.trigger(
            new Event({
              eventName: 'accountAddressRemoved',
              data: {
                addressId: payload.addressId,
              },
            }),
          );
        }
      }
      return response;
    },
    setDefaultBillingAddress: async (
      payload: SetDefaultAccountBillingAddressPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/setDefaultBillingAddress',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        const address = response.data.addresses?.find((address) => address.addressId === payload.addressId);
        if (address?.isDefaultBillingAddress) {
          sdk.trigger(
            new Event({
              eventName: 'defaultBillingAddressSet',
              data: {
                address: address,
              },
            }),
          );
        }
      }
      return response;
    },
    setDefaultShippingAddress: async (
      payload: SetDefaultAccountShippingAddressPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/setDefaultShippingAddress',
        payload,
        serverOptions: options.serverOptions,
      });

      if (response.isError === false) {
        const address = response.data.addresses?.find((address) => address.addressId === payload.addressId);
        if (address?.isDefaultShippingAddress) {
          sdk.trigger(
            new Event({
              eventName: 'defaultShippingAddressSet',
              data: {
                address: address,
              },
            }),
          );
        }
      }
      return response;
    },

    getCustomerNotes: async (payload: CustomerNotesPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        query: { ...payload },
        actionName: 'soaCustomer/getCustomerNotes',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    getCustomerPrefrence: async (
      payload: CustomerPreferencePayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<PreferencesResponse>({
        query: { ...payload },
        actionName: 'soaCustomer/getCustomerPreferences',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    getOrderHistory: async (payload: OrderHistoryPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<OrderHistoryResponse>({
        query: {
          ...payload,
        },
        actionName: 'soaOrder/getOrderHistory',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    getOrderDetails: async (payload: OrderDetailsPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<OrderDetailsResponse>({
        query: {
          ...payload,
        },
        actionName: 'soaOrder/getOrderDetails',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    addNewAddress: async (newAddressPayload: AddressPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        query: { ...newAddressPayload.query },
        payload: { ...newAddressPayload.data },
        actionName: 'soaCustomer/createCustomerAddress',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    updateCustomerAddress: async (
      updateAddressPayload: AddressPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const payload = {
        ...updateAddressPayload.data,
      };
      const response = await callActionMiddleware<any>({
        query: { ...updateAddressPayload?.query },
        payload,
        actionName: 'soaCustomer/updateCustomerAddress',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    addNote: async (notePayload: AddNotePayload, options: { serverOptions?: ServerOptions } = {}) => {
      const payload = notePayload?.data;
      const response = await callActionMiddleware<any>({
        query: {
          ...notePayload?.query,
        },
        payload,
        actionName: 'soaCustomer/addCustomerNote',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    updateCustomerDetails: async (
      customerDetailsPayload: UpdateCustomerDetialsPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const payload = { ...customerDetailsPayload?.data };
      const response = await callActionMiddleware<any>({
        query: {
          ...customerDetailsPayload?.query,
        },
        payload,
        actionName: 'soaCustomer/updateCustomerDetails',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    getCustomerRefundHistory: async (
      payload: RefundHistoryPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<any>({
        query: {
          ...payload,
        },
        actionName: 'soaCustomer/getRefundCheckHistory',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    getCustomerMailingHistory: async (
      payload: CatalogMailingHistoryPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<any>({
        query: { ...payload },
        actionName: 'soaCustomer/getMailingRecords',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    makePayment: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        query: {
          ...payload.query,
        },
        payload: { ...payload.data },
        actionName: 'soaCustomer/submitPayment',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    updateCustomerPreferences: async (
      updatePayload: updateCustomerPreferencesPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const payload = updatePayload?.data?.preferences;
      const response = await callActionMiddleware<any>({
        query: {
          ...updatePayload?.query,
        },
        payload,
        actionName: 'soaCustomer/updateCustomerPreferences',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    sendCatalog: async (catalogPayload: SendCatalogPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const payload = catalogPayload.catalogPayload;
      const response = await callActionMiddleware<any>({
        query: {
          ...catalogPayload.query,
        },
        payload,
        actionName: 'soaCustomer/sendCatalog',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    getSOAOrderHistoryForDashboard: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<SOADashBoardOrders>({
        actionName: 'account/getSOAOrderHistoryForDashboard',
        serverOptions: options.serverOptions,
      });
      if (response.isError === false) {
      }
      return response;
    },

    updateEmail: async (updatePayload: UpdateEmailPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        query: { ...updatePayload?.query },
        payload: { ...updatePayload?.data },
        actionName: 'soaCustomer/updateEmail',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    updatePhone: async (updatePayload: UpdatePhonePayload, options: { serverOptions?: ServerOptions } = {}) => {
      const payload = updatePayload.data;
      const response = await callActionMiddleware<any>({
        query: { ...updatePayload.query },
        payload,
        actionName: 'soaCustomer/updatePhone',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    addDivision: async (updatePayload: AddDivisionPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const payload = updatePayload.data;
      const response = await callActionMiddleware<any>({
        query: { ...updatePayload.query },
        payload,
        actionName: 'soaCustomer/addDivision',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    getOrderById: async (orderPayload: OrderByIdPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        query: { ...orderPayload.query },
        actionName: 'soaOrder/getOrderById',
        serverOptions: options.serverOptions,
      });
      return response;
    },

    tokenizeCard: async (payload: TokenizeCardPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaCustomer/tokenizeCard',
        serverOptions: options.serverOptions,
        payload: { ...payload.data },
        query: { ...payload.query },
      });
      return response;
    },

    enrollCreditProtection: async (
      payload: EnrollProtectionPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaCustomer/enrollCreditProtection',
        serverOptions: options.serverOptions,
        payload: payload,
      });
      return response;
    },

    getOrderLogs: async (payload: OrderTrackLogPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaOrder/getOrderLogs',
        serverOptions: options.serverOptions,
        query: { ...payload },
      });
      return response;
    },
    addOrderNote: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaOrder/addOrderNote',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
        payload: payload?.data,
      });
      return response;
    },

    sendTracer: async (payload: SendTracerPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaOrder/sendTracer',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
        payload: payload?.data,
      });
      return response;
    },

    getOrderEvents: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaOrder/getOrderEvents',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
        payload: payload?.data,
      });
      return response;
    },

    createCustomer: async (payload: CreateCustomerPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaCustomer/createCustomer',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
        payload: { ...payload?.data },
      });
      return response;
    },
    updateRecentlyViewedProducts: async (
      payload: RecentlyViewedProducts,
      options?: { serverOptions?: ServerOptions },
    ) => {
      const response = await callActionMiddleware<Response>({
        actionName: '/account/updateRecentlyViewedProducts',
        payload,
        serverOptions: options?.serverOptions,
      });
      return response;
    },
    getCreditHistory: async (payload: CreditHistory, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaCustomer/getCreditHistory',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
      });
      return response;
    },

    getCreditNotes: async (payload: CreditHistory, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaCustomer/getCreditNotes',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
      });
      return response;
    },

    getCustomerAddresses: async (payload: CustomerAddressPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaCustomer/getCustomerAddresses',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
      });
      return response;
    },

    getCustomerDetails: async (payload: CustomerDetailsPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaCustomer/getCustomerDetails',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
      });
      return response;
    },
    forgotPassword: async (payload: ForgotPassword, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'account/sendForgotPasswordEmail',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
        payload: { ...payload?.data },
      });
      return response;
    },
    sendClaimInsuranceEmail: async (payload: ClaimInsuranceBody, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'account/sendClaimInsuranceEmail',
        serverOptions: options.serverOptions,
        payload,
      });
      return response;
    },
    updateOrder: async (payload: UpdateOrderPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaOrder/updateOrder',
        serverOptions: options.serverOptions,
        payload: { ...payload?.data },
        query: { ...payload?.query },
      });
      return response;
    },
    startPhoneRecording: async (payload: PhoneRecordingPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaDataQuality/startPhoneRecording',
        serverOptions: options.serverOptions,
        payload: { ...payload?.data },
      });
      return response;
    },
    stopPhoneRecording: async (payload: PhoneRecordingPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaDataQuality/stopPhoneRecording',
        serverOptions: options.serverOptions,
        payload: { ...payload?.data },
      });
      return response;
    },
    validateAddress: async (payload: ValidateAddress, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaDataQuality/validateAddress',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
        payload: { ...payload?.data },
      });
      return response;
    },
    getHoldOrders: async (payload: HoldOrder, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<any>({
        actionName: 'soaOrder/getHoldOrdersHistory',
        serverOptions: options.serverOptions,
        query: { ...payload?.query },
      });
      return response;
    },

    decryptCreditCardData: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      payload = {
        data: payload,
      };
      const response = await callActionMiddleware<Account>({
        actionName: 'account/decryptCreditCardData',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    addCreditCard: async (payload: AddEditCreditCardPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/addCreditCard',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    editCreditCard: async (payload: AddEditCreditCardPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/editCreditCard',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    removeCreditCard: async (payload: RemoveCreditCardPayload, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/removeCreditCard',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    setDefaultCreditCard: async (
      payload: SetDefaultCreditCardPayload,
      options: { serverOptions?: ServerOptions } = {},
    ) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/setDefaultCreditCard',
        payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    getAccountData: async (options: { serverOptions?: ServerOptions } = {}) => {
      const response = await callActionMiddleware<Account>({
        actionName: 'account/getAccountData',
        serverOptions: options.serverOptions,
      });
      return response;
    },
    tokenizeAndUpdateOrder: async (payload: TokenizeCardPayload, options?: { serverOptions?: ServerOptions }) => {
      const response = await callActionMiddleware<Response>({
        actionName: 'soaOrder/tokenizeCardAndUpdateOrder',
        payload: { ...payload?.data },
        query: { ...payload?.query },
        serverOptions: options?.serverOptions,
      });
      return response;
    },

    isCTAccount: async (payload: any, options?: { serverOptions?: ServerOptions }) => {
      const response = await callActionMiddleware<Response>({
        actionName: 'account/ctAccount',
        query: { ...payload?.query },
        serverOptions: options?.serverOptions,
      });
      return response;
    },
  };
};
